import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import cisco from '../../../images/cisco.png';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [createData('Austin', 159, 6.0, 24), createData('Tokyo', 237, 9.0, 37), createData('Cork', 262, 16.0, 24)];

const Solar = () => {
  return (
    <>
      <section>
        <div
          className="flex-col bg-white m-10 rounded-lg mt-0 border-r border-b border-l border-gray-400 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r border-gray-400"
          style={{ margin: '20px 10px 10px 10px', height: '36vh' }}
        >
         <iframe src="https://monitor.bestel.com.mx/ui/maps/staticsubview/?NetObject=I:45621&ViewID=380&opid=Orion.NPM.Interfaces_45621&zoom=0.5&selected=0_N_5983&layoutId=LayoutGrid&memberIds=0_I_45630,0_I_45625,0_I_45623,0_I_45629,0_I_45628,0_I_45622,0_I_45627,0_I_45626,0_I_45624,0_HWHS_57426,0_HWHS_57422,0_HWHS_57423,0_HWHS_57407,0_HWHS_57411,0_HWHS_57410,0_HWHS_57409,0_HWHS_57408,0_HWHS_57424,0_HWHS_57425,0_HWHS_57421,0_HWHS_57420,0_HWHS_57414,0_HWHS_57419,0_HWHS_57412,0_HWH_2978,0_HWHT_7167,0_HWHT_7168,0_HWHT_7169,0_HWHS_57418,0_HWHS_57415,0_HWHS_57416,0_HWHS_57413,0_HWHS_57417&AccountID=SAT&Password=uhTj7AILXPjxTgk3ABX2"></iframe>
        </div>
      </section>
    </>
  );
};

export default Solar;
